import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SettingsHeader } from "~/components/layout/settings-header";
import ComingSoon from "~/components/miscellaneous/coming-soon";

export const Route = createFileRoute(
  "/_main/settings/_layout/communication/messages",
)({
  component: Messages,
});

function Messages() {
  const { t } = useTranslation("common");
  return (
    <>
      <SettingsHeader title={t("messages")} />
      <ComingSoon />
    </>
  );
}
